import { prefix } from "../../design-tokens/meta";
import { matchers } from "../../js/validate-props";

export const componentName = "TextArea";

export const defaultProps = Object.freeze({
    srLabel: "{remaining} characters remaining",
    counter: true,
    maxCounterLength: 140,
});

export const schema = Object.freeze({
    srLabel: matchers.minChars(1),
    counter: matchers.boolean,
    maxCounterLength: matchers.number,
});

export const componentClasses = Object.freeze({
    basic: `${prefix}text-area`,
    wrapper: `${prefix}text-area__wrapper`,
    counter: `${prefix}text-area__counter`,
    counterCurrent: `${prefix}current-value`,
    validated: `${prefix}text-area--validated`,
    sr: `${prefix}text-area__sr`,
    errorText: `${prefix}invalid-feedback`,
    error: `${prefix}error`,
    errorIcon: `${prefix}input-text__icon--end`,
    header: `${prefix}text-area__header`,
    helper: `${prefix}input-text__helper`,
    container: {
        base: `${prefix}text-area__container`,
        sm: `${prefix}text-area__container--sm`,
    },
});

export const views = Object.freeze({
    counterSpan: {
        valid: {
            classList: [`!${componentClasses.error}`],
        },
        invalid: {
            classList: [`${componentClasses.error}`],
        },
    },
    textArea: {
        valid: {
            attrs: { "aria-invalid": "false" },
        },
        invalid: {
            attrs: { "aria-invalid": "true" },
        },
        validated: {
            classList: [`${componentClasses.validated}`],
        },
    },
});
